import { CommonActionTypes, ClearStore } from './ActionTypes/common';

/**
 * Defines methods that create action objects for all objects
 * in the store
 */

export const clearStore = (): ClearStore => ({
    type: CommonActionTypes.ClearStore as CommonActionTypes.ClearStore
});

export type CommonAction = ReturnType<typeof clearStore>